import React from 'react'
import { Route, Routes } from 'react-router-dom'
import GroupDashboard from '../../pages/GroupPortal/GroupDashboard'
import MemberAttendance from '../../pages/GroupPortal/MemberAttendance'
import NotFound from '../../pages/NotFound'
import ChurchGroupMembers from '../../pages/GroupPortal/ChurchGroupMembers'
import AttendanceReport from '../../pages/GroupPortal/AttendanceReport'

const GroupsRoute = () => {
  const group_id = localStorage.getItem('selectedGroupId');
  if (!group_id) {
    window.location.href = '/login/group-selection';
  }
  return (
    <Routes>
        <Route path="/dashboard" element={<GroupDashboard />} />
        <Route path="/members" element={<ChurchGroupMembers />} />
        <Route path="/attendance" element={<MemberAttendance />} />
        <Route path="/attendance-report" element={<AttendanceReport />} />
        <Route path="/*" element={<NotFound />} />
    </Routes>
  )
}

export default GroupsRoute